import type {PropsWithChildren} from 'react'

import styles from './Result.module.css'

export default function Result({children}: PropsWithChildren) {
  return <div className={styles.Result}>{children}</div>
}
